import Crud from '../views/Webhook/Crud'
import Entity from '../views/Webhook/Add'
import View from '../views/Webhook/View'

let routes = {
    path: '/webhooks',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/webhooks/add',
            name: 'NewWebhook',
            component: Entity,
            meta: {
                pageTitle: 'Criação de Webhook',
                breadcrumb: [
                    {
                        text: 'Webhooks',
                        active: false,
                        to: '/webhooks',
                    },
                    {
                        text: 'Criar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/webhooks/edit/:id?',
            name: 'EditWebhook',
            component: Entity,
            meta: {
                pageTitle: 'Edição de Webhook',
                breadcrumb: [
                    {
                        text: 'Webhooks',
                        active: false,
                        to: '/webhooks',
                    },
                    {
                        text: 'Editar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/webhooks/view/:id?',
            name: 'ViewWebhook',
            component: View,
            meta: {
                pageTitle: 'Visualizar Webhook',
                breadcrumb: [
                    {
                        text: 'Webhooks',
                        active: false,
                        to: '/webhooks',
                    },
                    {
                        text: 'Visualizar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/webhooks',
            name: 'list-webhooks',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Webhooks',
                breadcrumb: [
                    {
                        text: 'Webhooks',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
